import { useState } from 'react';
import { useDropzone } from 'react-dropzone';

interface UseAsyncDropzoneArgs {
  onDrop: (files: File[]) => Promise<void>;
  onFileRejection: (rejectedFileTypes: string[]) => void;
  accept?: string | string[];
  noClick?: boolean;
}

export const useAsyncDropzone = ({ onDrop, onFileRejection, accept, noClick }: UseAsyncDropzoneArgs) => {
  const [, setError] = useState();

  return useDropzone({
    onDrop: async (newFiles: File[]) => {
      try {
        await onDrop(newFiles);
      } catch (error) {
        setError(() => {
          throw error;
        });
      }
    },
    accept,
    onDropRejected: (fileRejections) => onFileRejection(fileRejections.map(({ file }) => file.name)),
    multiple: true,
    noClick,
  });
};
